import AppConstants from 'constants/AppConstants';

export function validateTokenAndFetchWidgetContent(token: string): ApiAction {
  return {
    TockApi: {
      getProto: `/consumer/ticket/type?widgetToken=${token}`,
      type: AppConstants.WIDGET_BUILDER_FETCH_TICKET_TYPES,
    },
  };
}

export function saveToken(token: string): BaseTockAction {
  return {
    type: AppConstants.WIDGET_BUILDER_TOKEN,
    payload: token,
  };
}
